import Container from './TierBreadcrumbs.container';
import TierBreadcrumbs from './TierBreadcrumbs';

export default Container(TierBreadcrumbs);
